import { tinyCfg } from './config';

$(document).ready(function () {

    var hdfhApplication = (function () {

        var $window = $(window);

        let ajaxEndpoint = '/hdfh/application/';

        var init = function () {
            addEventListeners();
            return;
        };

        var addEventListeners = function () {
            tinymce.init({
                ...{selector: '.js-explanation-editor-text'}, ...tinyCfg
            });

            $('.js-app-toggle-mainpriceproposal').on('click', handleToggleMainpriceProposal);
            $('.js-app-explain-mainpriceproposal').on('click', handleEditExplanation);
            $('.js-explanation-editor--mppe .js-save-explanation').on('click', handleSaveMainpriceProposalExplanation);
            $('.js-explanation-editor--mppe .js-cancel-explanation').on('click', handleCancelMainpriceProposalExplanation);

            $('.js-app-explain-specialpriceproposal').on('click', handleEditExplanation);
            $('.js-explanation-editor--sppe .js-save-explanation').on('click', handleSaveSpecialpriceProposalExplanation);
            $('.js-explanation-editor--sppe .js-cancel-explanation').on('click', handleCancelSpecialpriceProposalExplanation);

            $('.js-app-toggle-specialpriceproposal').on('click', handleToggleSpecialpriceProposal);

        }

        // Event Listeners

        var handleToggleMainpriceProposal = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');
            let aid = $target.data('aid');

            let url = ajaxEndpoint + 'tmpp';
            let data = {
                applicationId: aid
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, updateMainProposal);
        }

        var handleToggleSpecialpriceProposal = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');
            let pid = $target.data('pid');

            let url = ajaxEndpoint + 'tspp';
            let data = {
                projectId: pid
            }

            console.log(data);

            ajaxPost(url, data, $container, $target, updateSpecialProposal);
        }

        var handleEditExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');

            if (!$container.hasClass('js-status-container--active')) {
                $container.addClass('js-status-container--active');
            }
        }

        var handleSaveMainpriceProposalExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            handleSaveExplanation($target, 'save_mppe', updateMainpriceProposalExplanation);
        }

        var handleSaveSpecialpriceProposalExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            handleSaveExplanation($target, 'save_sppe', updateSpecialpriceProposalExplanation);
        }

        var handleSaveExplanation = function ($target, action, callback) {
            let $container = $target.parents('.js-status-container');
            let $form = $target.parents('.js-edit-form-explanation');
            let aid = $form.find('input[name="aid"]').val();

            let text = tinymce.get(action).getContent();
            console.log(text);

            // let text = $form.find('.js-explanation-editor-text').val()

            let url = ajaxEndpoint + action;
            let data = {
                applicationId: aid,
                text: text
            }

            ajaxPost(url, data, $container, $target, callback);
        }

        var handleCancelMainpriceProposalExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);

            handleCancelExplanation($target, 'reset_mppe', resetMainpriceProposalExplanation);
        }

        var handleCancelSpecialpriceProposalExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);

            handleCancelExplanation($target, 'reset_sppe', resetSpecialpriceProposalExplanation);
        }

        var handleCancelExplanation = function ($target, action, callback) {
            let $container = $target.parents('.js-status-container');
            let $form = $target.parents('.js-edit-form-explanation');
            let aid = $form.find('input[name="aid"]').val();

            let url = ajaxEndpoint + action;
            let data = {
                applicationId: aid
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, callback);
        }


        // Callbacks

        var resetMainpriceProposalExplanation = function ($container, $target, data) {
            updateProposal($container, $target, data, 'main');
            resetExplanationForm($container, $target, data);
        }

        var resetSpecialpriceProposalExplanation = function ($container, $target, data) {
            updateProposal($container, $target, data, 'special');
            resetExplanationForm($container, $target, data);
        }

        var resetExplanationForm = function($container, $target, data) {
            let $form = $target.parents('.js-edit-form-explanation');
            $form.find('.js-explanation-editor-text').val(data['explanation']);
            $container.removeClass('js-status-container--active');
        }

        var updateMainpriceProposalExplanation = function ($container, $target, data) {
            updateProposal($container, $target, data, 'main');
            $container.removeClass('js-status-container--active');
        }

        var updateSpecialpriceProposalExplanation = function ($container, $target, data) {
            updateProposal($container, $target, data, 'special');
            $container.removeClass('js-status-container--active');
        }

        var updateMainProposal = function ($container, $target, data) {
            updateProposal($container, $target, data, 'main');
        }

        var updateSpecialProposal = function ($container, $target, data) {
            updateProposal($container, $target, data, 'special');
        }

        var updateProposal = function ($container, $target, data, type) {
            let $explanationButton = $container.find('.js-app-explain-' + type + 'priceproposal');
            let $toggleButton = $container.find('.js-app-toggle-' + type + 'priceproposal');

            $toggleButton.removeClass('button-ok');
            $explanationButton.removeClass('button-ok')
            $explanationButton.removeClass('button-alert');

            if (data['button'] === 'active') {
                $toggleButton.addClass('button-ok');
                if (data['hasExplanation']) {
                    console.log('set');
                    $explanationButton.addClass('button-ok');
                } else {
                    $explanationButton.addClass('button-alert');
                }
            }
        }

        // Helpers

        var ajaxPost = function (url, data, $container, $target, successCallback) {
            $.ajax({
                method: "POST",
                url: url,
                data: data,
                dataType: "json"

            }).done(function (returnData) {
                console.log(returnData);
                // if (returnData['success']) {
                //     console.log(returnData['numDocs']);
                // }

                if (returnData['success'] === '1') {
                    successCallback($container, $target, returnData);
                } else {
                    alert(returnData['errMessage'])
                }

            }).fail(function (jqXHR, textStatus) {
                console.log(textStatus);
            });
        }

        return {
            init: init
        }

    })();

    hdfhApplication.init();

});



